<template>
  <div class="search-input-1 d-flex">
    <i @click="search()" class="search-input-1-icon bi bi-search"/>
    <input @keyup.enter="search()" :placeholder="$t('nav.search_placeholder')" type="text" v-model.trim="words"
           class="search-input-1-input border-0 search-input-1-form-absolut-data">
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "SearchInput200",
  data() {
    return {
      words: '',
      type: 'all',
    }
  },
  methods: {
    search() {
      router.push({name: 'Search', params: {words: this.words, type: this.type}})
    }
  }
}
</script>

<style scoped>
.search-input-1 {
  background: white;
}

.search-input-1 .search-input-1-input {
  padding: 5px;
  width: 100%;
  background: transparent;
}

.search-input-1-icon {
  z-index: 100;
  position: relative;
  background-color: transparent;
  padding: 5px 15px 0 0;
}

.search-input-1-form-absolut-data {
  width: 100%;

}

.search-input-1 input::placeholder {
  font-size: 16px;
  text-align: right;
}

.search-input-1 input:focus-visible {
  outline: none;
}

</style>